import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, Button, Form, Label } from 'reactstrap';
import _ from 'lodash';
import { sharedLabelsPath } from "../../../reducers/common/localization";
import FormWrapper from "../../commonComponents/formWrapper/FormWrapper.container";

export const actionType = {
    CANCEL: "cancel",
    DISMISS: "dismiss"
};

class CancelConsentRequestModal extends Component {
    render() {
        if (_.isNil(this.props.id)) {
            return null;
        }

        return (
            <Modal className="cancel-consent-request-modal" isOpen={this.props.isOpen}
                toggle={this.handleCancel}>
                <ModalBody>{this.renderModalBody()}</ModalBody>
            </Modal>
        );
    }

    renderModalBody() {
        return (
            <FormWrapper successMessage={_.get(this.props.translation, "consents.cancel_request_success_message")}>
                <Form>
                    <h6>{_.get(this.props.translation, "consents." + this.props.actionType + "_request_warning_label")}</h6>
                    <Label>{_.get(this.props.translation, "consents." + this.props.actionType + "_request_are_you_sure_label")}</Label>
                    <div className="modal-buttons-container">
                        <Button color='secondary'
                            onClick={this.handleCancel}>{_.get(this.props.translation, sharedLabelsPath.cancel_button)}</Button>
                        <Button className="carrot-red-btn"
                            onClick={this.handleCancelConsentRequest}>{_.get(this.props.translation, "consents." + this.props.actionType + "_request_button_label")}</Button>
                    </div>
                </Form>
            </FormWrapper>
        );
    }

    handleCancelConsentRequest = (e) => {
        e.preventDefault();

        this.props.onAbandonConsentRequest(this.props.id);
    };

    handleCancel = () => {
        this.props.onCancel();
    };
}

CancelConsentRequestModal.propTypes = {
    id: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    translation: PropTypes.object.isRequired,
    onAbandonConsentRequest: PropTypes.func,
    onCancel: PropTypes.func
};

export default CancelConsentRequestModal;



// WEBPACK FOOTER //
// ./src/components/organizationConsentManagement/cancelConsentRequestModal/ConsentRequestModal.js